import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/utils';
import { AuthenticationProvider } from '@onemedical/auth';
import { v5Theme } from '@onemedical/react-theme';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ApolloWrapper from './app/wrappers/ApolloWrapper';

import App from './app/App';

// TODO: import from @onemedical/rna/index.css once RNA supports this
import '@onemedical/rna/lib/cjs/index.cjs.css';

const LDProvider = withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID!,
  options: { streaming: !window.Cypress },
})(({ children }) => children as React.ReactElement);

// namespace mui component css
ClassNameGenerator.configure((componentName) => `onelife-container-${componentName}`);

render(
  <AuthenticationProvider
    providerUrl={process.env.REACT_APP_AUTH_PROVIDER_URL!}
    clientID={process.env.REACT_APP_AUTH_CLIENT_ID!}
    audience="https://onemedical.com"
    scope="openid profile email user/Procedure.read user/Patient.read user/Observation.read user/Condition.read user/MedicationDispense.read user/Encounter.read user/DocumentReference.read user/DiagnosticReport.read user/Provenance.read user/QuestionnaireResponse.read"
    callbackPath="/oauth"
    auth0Connection={process.env.REACT_APP_AUTH0_CONNECTION}
    auth0LogoutReturnTo={`${process.env.REACT_APP_ONELIFE_URL}/auth/logout`}
  >
    <LDProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={v5Theme}>
          <CssBaseline />
          <BrowserRouter>
            <ApolloWrapper>
              <App />
            </ApolloWrapper>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </LDProvider>
  </AuthenticationProvider>,
  document.getElementById('root'),
);
